import {KeyConstant} from "../constant/keyConstant";

export const mapNameLastMonth = (type) =>{
    switch (type){
        case KeyConstant.TODAY:
            return "Ngày hôm nay"
        case KeyConstant.YESTERDAY:
            return "Ngày hôm qua"
        case KeyConstant.THIS_WEEK:
            return "Tuần này"
        case KeyConstant.LAST_WEEK:
            return "Tuần trước"
        case KeyConstant.THIS_MONTH:
            return "Tháng này"
        case KeyConstant.LAST_MONTH:
            return "Tháng trước"
        case KeyConstant.SEVEN_DAYS_AGO:
            return "7 ngày trước"
        case KeyConstant.THIRTY_DAYS_AGO:
            return "28 ngày trước"
        case KeyConstant.NINETY_DAYS_AGO:
            return "90 ngày trước"
        default :
            return "Từ ngày"
    }
}
